import {
    debounce
} from './_utils.js';



export default (() => {

    const container = document.querySelector('.st-container');
    const overlay = document.querySelector('#st-pusher-overlay');
    const button = document.querySelector('.offcanvas-toggle .burger');


    overlay.addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();
        container.classList.remove('st-menu-open');
        button.classList.remove('close');
    });

    button.addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();
        container.classList.toggle('st-menu-open');
        button.classList.toggle('close');
    });

    

})();




